module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pagenotfound"
  }, [_c('div', [_c('div', [_c('h1', [_vm._v("The page you requested is not available!")]), _vm._v(" "), _c('router-link', {
    staticClass: "button-type-i",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c3d2e0e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageNotFound.vue
// module id = 145
// module chunks = 0